import { useNavigate, useLocation } from "react-router-dom";
import React from "react";
import { Card } from "@ui5/webcomponents-react";
import MenuBar from "../components/MenuBar";

const OverviewPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const role = location.state?.role || localStorage.getItem("userRole");

  const roleNames = {
    "1": "Administrator",
    "2": "Manager",
    "3": "User",
    "9": "Super Admin"
  };

  return (
    <div style={{ padding: "2rem" }}>
      <MenuBar />
      {/* User Info Header */}
      <div style={{
        textAlign: "center",
        marginBottom: "2rem",
        padding: "1rem",
        backgroundColor: "#f5f7fa",
        borderRadius: "8px"
      }}>
        <h2>Welcome to Emergency Monitoring System</h2>
        <p style={{ fontSize: "1.1rem" }}>
          Logged in as: <strong>{roleNames[role] || role}</strong>
        </p>
      </div>
    </div>
  );
};

export default OverviewPage;